import { Linkedin, Mail, Facebook } from 'lucide-react';
import { FaInstagram } from 'react-icons/fa';

export default function Footer({ darkMode }) {
  return (
    <footer className={`transition-colors duration-300
      ${darkMode ? 'bg-[#080D1A] border-t border-[#C9A84C]/10' : 'bg-[#F0EDE6] border-t border-[#C9A84C]/20'}`}>
      <div className="container mx-auto px-4 lg:px-16 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">

          {/* Brand */}
          <div className="flex items-center gap-3">
            <span className={`text-lg font-bold tracking-widest text-[#C9A84C]`}>RISECAP</span>
            <span className={`text-xs ${darkMode ? 'text-gray-600' : 'text-gray-400'}`}>·</span>
            <p className={`text-xs ${darkMode ? 'text-gray-500' : 'text-gray-500'}`}>
              &copy; {new Date().getFullYear()} Manoj Pant. All rights reserved.
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-3">
            {[
              { href: 'https://www.linkedin.com/in/manojpant991123/', icon: <Linkedin size={16} /> },
              { href: 'mailto:risecap212@gmail.com', icon: <Mail size={16} /> },
              { href: 'https://www.instagram.com/risecap_finance/?hl=en', icon: <FaInstagram size={16} /> },
              { href: 'https://www.facebook.com/profile.php?id=100093338240391', icon: <Facebook size={16} /> },
            ].map((s, i) => (
              <a key={i} href={s.href}
                className={`w-8 h-8 rounded-lg flex items-center justify-center border transition-all
                  ${darkMode
                    ? 'border-[#C9A84C]/15 text-gray-500 hover:border-[#C9A84C] hover:text-[#C9A84C]'
                    : 'border-[#C9A84C]/25 text-gray-400 hover:border-[#C9A84C] hover:text-[#8B6914]'
                  }`}>
                {s.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}